import { createApiMutation } from "../../generated-factory";
import { apiClientManager } from "@app/stores/api-manager";
import type { UseCancelMemberVoucherRequest, UseCancelMemberVoucherData, UseDeleteBillingRequest, UseDeleteBillingData, UseDeleteVoucherRequest, UseDeleteVoucherData } from "@api/@types/charge";

export const useCancelMemberVoucher = createApiMutation<UseCancelMemberVoucherData, UseCancelMemberVoucherRequest>({
  mutationFn: (req) => apiClientManager.apis.charge.cancelMemberVoucher(req as UseCancelMemberVoucherRequest),
});

export const useDeleteBilling = createApiMutation<UseDeleteBillingData, UseDeleteBillingRequest>({
  mutationFn: (req) => apiClientManager.apis.charge.deleteBilling(req as UseDeleteBillingRequest),
});

export const useDeleteVoucher = createApiMutation<UseDeleteVoucherData, UseDeleteVoucherRequest>({
  mutationFn: (req) => apiClientManager.apis.charge.deleteVoucher(req as UseDeleteVoucherRequest),
});

export type { UseCancelMemberVoucherRequest, UseCancelMemberVoucherData, UseDeleteBillingRequest, UseDeleteBillingData, UseDeleteVoucherRequest, UseDeleteVoucherData } from "@api/@types/charge";
